/**
 * Mapping of the name of an interface or union type (the supertype)
 * to the types that implement or belong to it (the subtypes)
 * (https://www.apollographql.com/docs/react/data/fragments/#using-fragments-with-unions-and-interfaces)
 *
 * All unions of GraphQL schema should be represented here (keys are unions names, array values are unions values).
 *
 * Example: "union Assignment = Approver | Receiver | Supplier" -> "Assignment: ['Approver', 'Receiver', 'Supplier']"
 */

const possibleTypes = {
  AchievementAwarded: ['TrophyAwarded', 'BadgeAwarded'],
  Assignment: ['Approver', 'Receiver', 'Supplier'],
  CommentMarker: [
    'CommentCircleMarker',
    'CommentPinMarker',
    'CommentRectangleMarker',
    'CommentLineMarker',
    'MeasurementCommentLineMarker',
    'MeasurementCommentRectangleMarker',
  ],
  DownloadFileDescriptor: ['DownloadFile', 'DownloadFolder'],
  FileHistoryEntry: ['FileAdded', 'FileRemoved', 'Checkin', 'Checkout', 'DiscardCheckout', 'FileTypeChanged'],
  FolderItem: ['FileFolderItem', 'ArtworkFolderItem'],
  Marker: ['CircleMarker', 'PinMarker', 'RectangleMarker', 'LineMarker', 'MeasurementLineMarker', 'MeasurementRectangleMarker'],
  RevisionEvent: ['Correction', 'RevisionSystemLog'],
  UserOrTeam: ['User', 'UserTeam'],
  UserTask: ['ApproveArtworkTask', 'UploadRevisionTask', 'DownloadShareTask', 'BundleArtworkTask', 'DeliverArtworkTask', 'SeatRequestTask'],
};

export default possibleTypes;
